import {
  TEAMS_BY_CODE,
  TEAMS_BY_EVENT,
  TEAMS_BY_USER,
  TEAMS_SEND_EMAIL,
  TEAMS_TEAM_CODES,
} from '@gameday/common/constants/endpoints'

export default {
  getTeamsByUser: TEAMS_BY_USER, // 'gamedayapi/teams/byuser',
  getTeamsByCode: TEAMS_BY_CODE, // 'gamedayapi/teams/bycode',
  getAllTeamCodes: TEAMS_TEAM_CODES, // 'gamedayapi/teams/teamcodes',
  sendEmailTeamRego: TEAMS_SEND_EMAIL, // 'gamedayapi/teams/sendemailteamrego',
  getTeamsInEvent: TEAMS_BY_EVENT, // 'gamedayapi/teams/byevent',
}
